import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

const idusuario = localStorage.getItem("idusuario");

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        codigo: '',
        nombre: '',
        id_capitulo: '',
        id_tipo_unidad: '',
        usuario: idusuario,
        capitulos: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { codigo, nombre, id_capitulo, id_tipo_unidad } = this.state;
        var errores = [];
        if (!codigo) { errores.push("error_codigo"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_capitulo) { errores.push("error_id_capitulo"); }
        if (!id_tipo_unidad) { errores.push("error_id_tipo_unidad"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            codigo: codigo,
            nombre: nombre,
            id_tipo_unidad: id_tipo_unidad,
            id_capitulo: id_capitulo,
            usuario: idusuario,
            estado: 1
        }
        Swal.showLoading();
        authAxios.post("productos/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta.data)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Productos!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/UpProductos/" + datosRespuesta.data.ID);
                } else {
                    Swal.close();
                    Swal.fire(
                        'Productos!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("capitulos/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta.data.lista);
                this.setState({ datosCargados: true, capitulos: datosRespuesta.data.lista.data, codigo: datosRespuesta.data.codigo, load: '' });
                Swal.close();
            })
    }
    render() {
        const { codigo, nombre, id_capitulo, id_tipo_unidad, capitulos } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE PRODUCTO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="id_capitulo">Categoría</label>
                                                    <select name="id_capitulo" id="id_capitulo"
                                                        className={((this.verificarError("error_id_capitulo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Categoría</option>
                                                        {
                                                            capitulos.map((itemCapitulos) => (
                                                                <option key={itemCapitulos.ID_TABLA} value={itemCapitulos.ID_TABLA}>{itemCapitulos.ID_CAPITULO} - {itemCapitulos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Categoría</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo">Código</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_codigo")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="codigo" id="codigo" value={codigo} placeholder="Código" aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_tipo_unidad">Unidad</label>
                                                    <select name="id_tipo_unidad" id="id_tipo_unidad"
                                                        className={((this.verificarError("error_id_tipo_unidad")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Unidad</option>
                                                        <option value="1">Global (GLB)</option>
                                                        <option value="2">Metros (M)</option>
                                                        <option value="3">Rollo</option>
                                                        <option value="4">Unidad (UND)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Unidad</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-8">
                                                    <label htmlFor="nombre">Descripción</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + ' form-control form-control-sm'} id="nombre" name="nombre" rows='3' onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite el Producto</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Producto</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterProductos"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;